import React from 'react';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle } from 'react-icons/fa';

const ConfirmModal = ({ isOpen, onRequestClose, onConfirm, message, confirmLabel, cancelLabel, danger = true }) => {
    const { t } = useTranslation();
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Confirm Action"
            className="fixed inset-0 flex items-center justify-center z-50 px-4"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40 backdrop-blur-sm"
            ariaHideApp={false}
        >
            <div className="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full flex flex-col gap-4">
                <div className="flex flex-col items-center text-center gap-3">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${danger ? 'bg-red-50' : 'bg-blue-50'}`}>
                        <FaExclamationTriangle className={`text-xl ${danger ? 'text-red-500' : 'text-blue-500'}`} />
                    </div>
                    <p className="whitespace-pre-line text-sm text-gray-600 leading-relaxed break-words">
                        {message}
                    </p>
                </div>
                <div className="flex gap-2 mt-1">
                    <button
                        onClick={onConfirm}
                        className={`flex-1 py-3 rounded-xl font-semibold text-sm text-white transition ${danger
                                ? 'bg-red-500 hover:bg-red-600'
                                : 'bg-blue-600 hover:bg-blue-700'
                            }`}
                    >
                        {confirmLabel || t("yes")}
                    </button>
                    <button
                        onClick={onRequestClose}
                        className="flex-1 py-3 rounded-xl font-semibold text-sm bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
                    >
                        {cancelLabel || t("no")}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmModal;
